// extracted by mini-css-extract-plugin
module.exports = {"observer":"observer_observer__qkncq"};